import { ROUTE_REFERENCES } from '@shared/duck';

import { ReferencesPage } from './ReferencesPage';

export const routes = {
  [ROUTE_REFERENCES]: {
    path: '/references',
    Component: ReferencesPage,
    titleId: 'page.references',
  },
};
